'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductDescription({ product }: { product: ProductDetailData }) {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);

  return (
    <HtmlRenderer
      className={cn('text-sm', 'ea-product-detail-tab-description__container')}
      html={selectedVariant?.description ?? product.description}
    />
  );
}
